import Axios from "axios";
import { tallyStaticRepAxios, tallyCrudRepAxios, tallyOrgCompaniesAxios, Gstr2aAxios } from "src/config/axios.config";
// import { use}
import {
  SAVE_MESSAGE,
  SAVE_MESSAGE_SUCCESS,
  SAVE_MESSAGE_FAILURE,
  GET_MESSAGE,
  GET_MESSAGE_SUCCESS,
  GET_MESSAGE_FAILURE,
  SAVE_USER_FEEDBACK,
  SAVE_USER_FEEDBACK_SUCCESS,
  SAVE_USER_FEEDBACK_FAILURE
} from "../actionTypes";


const saveChatMessage = (data) => (dispatch) => {
  // Intitial Dispatch // can be used to show loader
  dispatch({
    type: SAVE_MESSAGE,
  });

  return tallyCrudRepAxios
    .post(`tally/saveUserComments`, data)
    .then(
      (res) =>
        dispatch({
          type: SAVE_MESSAGE_SUCCESS,
          payload: res.data,
        }),
      (err) =>
        dispatch({
          type: SAVE_MESSAGE_FAILURE,
          payload: err,
        })
    );
};
const getChatMessage = (id) => (dispatch) => {
  // Intitial Dispatch // can be used to show loader
  dispatch({
    type: GET_MESSAGE,
  });

  return tallyCrudRepAxios
    .post(`tally/getUserCommentsListByRefId?refId=${id}`, {})
    .then(
      (res) =>
        dispatch({
          type: GET_MESSAGE_SUCCESS,
          payload: res.data,
        }),
      (err) =>
        dispatch({
          type: GET_MESSAGE_FAILURE,
          payload: err,
        })
    );
};
const saveUserFeedback = (data) => (dispatch) => {
  dispatch({
    type: SAVE_USER_FEEDBACK,
  });

  return Gstr2aAxios
    .post(`user_feedback/`, data)
    .then(
      (res) =>
        dispatch({
          type: SAVE_USER_FEEDBACK_SUCCESS,
          payload: res.data,
        }),
      (err) =>
        dispatch({
          type: SAVE_USER_FEEDBACK_FAILURE,
          payload: err,
        })
    );
};
export {
  saveChatMessage,
  getChatMessage,
  saveUserFeedback
};